import React, { useState, useEffect, useRef } from "react";
import Modal from "./Modal";
import styled from "styled-components";
import GlobalStyle from "./GlobalStyle";
import { motion } from "framer-motion";
import { SiVelog } from "react-icons/si";
import { FaGithub, FaAngleUp } from "react-icons/fa6";

const IconGithub = styled(FaGithub)`
  margin-right: 7px;
`;
const IconVelog = styled(SiVelog)`
  margin-right: 7px;
`;
const IconTop = styled(FaAngleUp)`
  color: #222831;
  font-size: 1.5rem;
`;
const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  overflow: hidden;
  @media (min-width: 1024px) {
    width: 1024px;
    padding: 0;
  }
`;
const Intro = styled(motion.section)`
  width: 100%;
  height: 100vh;
  background: #ffffff;
  color: #222831;
  font-family: "Pretendard-SemiBold";
  position: relative;
`;
const Header = styled(motion.header)`
  display: flex;
  justify-content: center;
  padding: 20px 0;
  font-size: 25px;
  div {
    position: relative;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    transition-duration: 400ms;
    transition-property: color;
    &:first-child {
      margin-right: 1.5rem;
    }
    &:hover {
      color: #222222;
    }
    &:hover::after {
      width: 100%;
      left: 0%;
    }
    &::after {
      content: "";
      background: #222222;
      pointer-events: none;
      bottom: -10px;
      left: 50%;
      position: absolute;
      width: 0%;
      height: 3px;
      transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
      transition-duration: 400ms;
      transition-property: width, left;
    }
  }
  @media (min-width: 1024px) {
    padding: 40px 0;
  }
`;
const Main = styled.main`
  height: 100%;
  @media (min-width: 1024px) {
    display: flex;
  }
`;
const TextArea = styled(motion.div)`
  margin-top: 2rem;
  p {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  span {
    font-size: 24px;
    font-family: "Pretendard-Bold";
  }
  b {
    font-size: 30px;
    font-family: "Pretendard-Bold";
  }
  div {
    font-size: 18px;
    text-align: center;
    &:last-child {
      display: none;
      font-size: 16px;
      margin-top: 2rem;
      line-height: 180%;
      font-family: "Pretendard-Medium";
      > span {
        font-size: 16px;
        padding: 0.15rem 0.3rem;
        background: #ececec;
        border-radius: 0.25rem;
        font-family: "Pretendard-SemiBold";
      }
    }
  }
  @media (min-width: 1024px) {
    margin-top: 4.5rem;
    p {
      font-size: 25px;
    }
    span {
      font-size: 45px;
    }
    b {
      font-size: 60px;
    }
    div {
      text-align: start;
      &:last-child {
        font-size: 18px;
        display: block;
        > span {
          font-size: 18px;
        }
      }
    }
  }
`;
const ImageArea = styled(motion.div)`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  img {
    width: 12rem;
  }
  @media (min-width: 1024px) {
    left: 75%;
    img {
      width: 15rem;
    }
  }
`;
const Title = styled.h1`
  font-size: 35px;
  font-family: "Pretendard-SemiBold";
  margin-bottom: 4rem;
  @media (min-width: 1024px) {
    font-size: 3.5rem;
  }
`;
const SubTitle = styled.h2`
  font-size: 30px;
  font-family: "Pretendard-SemiBold";
  margin-bottom: 30px;
  text-align: center;
  margin-bottom: 3rem;
  @media (min-width: 1024px) {
    font-size: 45px;
    margin-bottom: 4rem;
  }
`;
const AboutMe = styled(motion.section)`
  padding: 6rem 0;
`;

const Values = styled(motion.article)`
  font-size: 16px;
  position: relative;
  ul {
    width: 100%;
    padding: 1rem;
    background: #343439;
    list-style: disc;
    border-radius: 1rem;
    line-height: 140%;
    li {
      margin-left: 1rem;
      padding: 10px 0 10px 0;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  div {
    display: none;
    text-align: end;
    position: absolute;
    bottom: 0;
    right: 0;
    img {
      width: 80%;
    }
  }
  @media (min-width: 1024px) {
    font-size: 1.5rem;
    ul {
      width: 90%;
      padding: 40px 50px 40px 60px;
    }
    div {
      display: block;
    }
  }
`;
const B = styled.span`
  font-size: 16px;
  padding: 0.15rem 0.3rem;
  background: #222222;
  border-radius: 0.25rem;
  @media (min-width: 1024px) {
    font-size: 1.4rem;
  }
`;
const Skill = styled(motion.article)`
  padding: 6rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    width: 100%;
    background: #343439;
    border-radius: 1rem;
    margin-bottom: 2rem;
    padding: 30px 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  h3 {
    font-family: "Pretendard-Medium";
    font-size: 23px;
    text-align: center;
    margin-bottom: 2rem;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    font-size: 16px;
    li {
      border-radius: 7px;
      background: #eeeeee;
      color: #222831;
      padding: 7px 20px;
      display: flex;
      align-items: center;
      img {
        width: 18px;
        margin-right: 7px;
        vertical-align: top;
      }
    }
  }
  @media (min-width: 1024px) {
    div {
      padding: 30px 14rem;
    }
    h3 {
      font-size: 30px;
    }
    ul {
      font-size: 18px;
      img {
        width: 20px;
      }
    }
  }
`;
const Certi = styled.article`
  > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    @media (min-width: 1024px) {
      align-items: center;
    }
  }
`;
const CertiItem = styled.div`
  font-family: "Pretendard-Medium";
  align-items: center;
  background: #343439;
  border-radius: 1rem;
  padding: 15px;
  b {
    display: inline-block;
    font-size: 19px;
    margin-bottom: 7px;
  }
  p {
    color: #a1a1a1;
  }
  @media (min-width: 1024px) {
    width: 70%;
    display: flex;
    justify-content: space-between;
    padding: 20px 40px;
    b {
      font-size: 1.7rem;
      margin-bottom: 0;
    }
  }
`;
const Experience = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  @media (min-width: 1024px) {
    width: 1024px;
    padding: 0;
  }
`;
const ExContainer = styled.div`
  display: flex;
  flex-direction: column;
  main {
    flex-basis: 73%;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Pretendard-SemiBold";
  background: #222831;
  opacity: 0.9;
  padding: 7px 0;
  margin-bottom: 2rem;
  @media (min-width: 1024px) {
    height: 100vh;
    top: 3rem;
    display: block;
    align-self: flex-start;
  }
`;
const NavItem = styled.p`
  font-size: 28px;
  color: #eeeeee45;
  margin: 0 10px;
  transition: 0.3s;
  cursor: pointer;

  ${({ $active }) => $active && "transition: .3s; color: #EEEEEE;"};

  @media (min-width: 1024px) {
    font-size: 3.5rem;
    margin: 0;
    ${({ $active }) => $active && "font-size: 3.8rem;"};
  }
`;

const Career = styled.article`
  overflow: hidden;
  margin-bottom: 6rem;
  font-family: "Pretendard-Medium";
  span {
    font-size: 15px;
    display: inline-block;
    color: #a1a1a1;
    margin-bottom: 1.2rem;
  }
  h3 {
    font-size: 22px;
    margin-bottom: 15px;
  }
  h4 {
    font-size: 17px;
    margin-bottom: 2rem;
  }
  ul {
    font-family: "Pretendard-Regular";
    font-size: 16px;
    color: #a1a1a1;
    list-style: disc;
    padding-left: 1rem;
    line-height: 130%;
    li {
      margin: 7px 0;
    }
  }
  @media (min-width: 1024px) {
    span {
      font-size: 1.1rem;
    }
    h3 {
      font-size: 1.7rem;
      font-size: 1.7rem;
      font-family: "Pretendard-Medium";
      font-size: 1.7rem;
      font-family: "Pretendard-Medium";
      margin-bottom: 0.5rem;
    }
    h4 {
      font-size: 1.15rem;
    }
    ul {
      font-size: 1.1rem;
      line-height: 150%;
      li {
        margin: 12px 0;
      }
    }
  }
`;
const CareerBox = styled(motion.div)`
  background: #343439;
  border-radius: 1rem;
  padding: 1.2rem;
  @media (min-width: 1024px) {
    padding: 1.5rem 2rem;
  }
`;
const Tech = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  margin-top: 4rem;
  gap: 10px;
  div {
    width: 4rem;
    height: 4rem;
    background: #222831;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    //margin-right: 10px;
    padding: 7px 5px;
    img {
      width: 35px;
      margin: auto 0;
    }
    p {
      display: flex;
      font-size: 9px;
    }
  }
  @media (min-width: 1024px) {
    margin-top: 4.5rem;
    div {
      width: 4.6rem;
      height: 4.6rem;
      img {
        width: 42px;
      }
      p {
        font-size: 10px;
      }
    }
  }
`;
const Project = styled.article`
  padding-bottom: 7rem;
`;
const Cards = styled(motion.div)`
  display: grid;
  grid-template-columns: 1;
  gap: 1.7rem;
  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.7rem;
  }
`;
const Card = styled.div`
  background: #343439;
  border-radius: 1rem;
  cursor: pointer;
  position: relative;
  bottom: 0;
  transition: ease-in-out 0.3s;
  &:hover {
    bottom: 7px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  }
`;
const CardImg = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  img {
    border-top-right-radius: 1rem;
    border-top-left-radius: 1rem;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const CardInfo = styled.div`
  padding: 12px;
  h3 {
    font-family: "Pretendard-Medium";
    font-size: 18px;
    margin-bottom: 5px;
  }
  span {
    display: inline-block;
    color: #a1a1a1;
    margin-bottom: 14px;
    font-size: 14px;
  }
  p {
    font-size: 16px;
    margin-bottom: 17px;
    line-height: 130%;
  }
  li {
    display: inline-block;
    border-radius: 7px;
    padding: 5px 9px;
    margin: 0 6px 6px 0;
    font-size: 13px;
  }
  @media (min-width: 1024px) {
    padding: 1rem 1.2rem;
    h3 {
      font-size: 1.4rem;
    }
    span {
      font-size: 16px;
    }
    p {
      font-size: 1.1rem;
    }
    li {
      font-size: 16px;
      margin: 0 8px 8px 0;
    }
  }
`;
const Keyword = styled.li`
  color: #ffffff;
  background: ${(props) => {
    switch (props.$keyword) {
      case "개인":
        return "#7EA883";
      case "팀":
        return "#B15959";
      case "React":
        return "#8C8CCD";
      case "Javascript":
        return "#CDB17B";
      case "HTML":
        return "#D07F7F";
      case "styled-components":
        return "#D18BC6";
      case "Tailwind CSS":
        return "#7394E8";
      case "React Native":
        return "#D0956A";
      case "Firebase":
        return "#6DB4CA";
      case "외주":
        return "#757881";
      case "반응형":
        return "#3CA38A";
      default:
        return "gray";
    }
  }};
`;
const Thanks = styled.section`
  height: 100vh;
  background: #ffffff;
  color: #222831;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  h1 {
    font-family: "Pretendard-Bold";
    font-size: 60px;
    color: #27272a1a;
    margin-top: 10rem;
  }
  h2 {
    font-family: "Pretendard-SemiBold";
    font-size: 18px;
    line-height: 135%;
    margin: 1rem 0 5rem 0;
  }
  @media (min-width: 1024px) {
    h1 {
      font-size: 10rem;
    }
    h2 {
      font-size: 1.5rem;
      font-size: 1.5rem;
      line-height: 135%;
      font-size: 1.5rem;
      line-height: 135%;
      margin: -1rem 0 5rem 0;
    }
  }
`;
const Contact = styled(motion.div)`
  margin-top: 0;
  display: flex;
  justify-content: center;
  text-align: center;
  a,
  button {
    img {
      width: 60px;
    }
  }
`;
const Github = styled.div`
  margin-right: 2rem;
`;
const Email = styled.div`
  position: relative;
  p {
    position: absolute;
    left: 50%;
    top: 3.7rem;
    opacity: 0;
    transform: translate(-50%, 0);
    transition: ease-in-out 0.3s;
    @media (min-width: 1024px) {
      left: 3.7rem;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
`;
const EmailLink = styled.button`
  &:hover ~ p {
    top: 4.7rem;
    opacity: 1;
    transition: ease-in-out 0.3s;
    @media (min-width: 1024px) {
      top: 50%;
      left: 4.7rem;
    }
  }
`;
const Footer = styled.footer`
  font-size: 11px;
  margin-bottom: 1.5rem;
  color: #c6c6c6;
  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

const TopBtn = styled.button`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1001;
  margin: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.2);
    &:hover ~ p {
      bottom: 0;
      opacity: 1;
    }
  }
  p {
    margin-top: 7px;
    color: #a1a1a1;
    font-size: 14px;
    position: relative;
    bottom: -3px;
    opacity: 0;
    transition: 0.3s;
  }
  @media (min-width: 1024px) {
    margin: 1.5rem;
  }
`;

function App() {
  const cardData = [
    {
      title: "법무법인 웹사이트 리뉴얼",
      period: "2023.08 - 2023.09",
      summary:
        "기존 사이트를 리디자인하고 반응형 페이지로 개선하는 프로젝트에 참여했습니다.",
      keyword: ["팀", "외주", "React", "Tailwind CSS", "반응형"],
      image: "project_law.png",
    },
    {
      title: "북마크 안드로이드 앱",
      period: "2023.11 - 2024.01",
      summary:
        "관심있는 링크를 저장하고 분류별로 모아 관리할 수 있는 북마크 앱 개발에 참여했습니다.",
      keyword: ["팀", "React Native", "Tailwind CSS"],
      image: "project_bookmark.png",
    },
    {
      title: "재생에너지 거래 중개 플랫폼",
      period: "2023.09 - 2024.01",
      summary:
        "재생에너지 전력 거래를 위한 REC 중개 플랫폼 개발에 참여했습니다.",
      keyword: ["팀", "React", "Tailwind CSS"],
      image: "project_rec.jpg",
    },
    {
      title: "컵일기",
      period: "2024.06 - 2024.08",
      summary:
        "카페 탐방 취미를 위해 카페 리뷰와 일기를 함께 기록할 수 있는 사이트입니다.",
      keyword: ["개인", "React", "styled-components", "Firebase"],
      image: "project_diary.png",
    },
    {
      title: "매거진 메이커",
      period: "2024.04 - 2024.05",
      summary:
        "카페 탐방 취미를 위해 카페 리뷰와 일기를 함께 기록할 수 있는 사이트입니다.",
      keyword: ["개인", "HTML", "styled-components", "Javascript"],
      image: "project_magazine.png",
    },
    {
      title: "개인 포트폴리오 사이트",
      period: "2024.08 ~",
      summary: "다양한 프로젝트와 경험을 담아낸 개인 포트폴리오 사이트입니다.",
      keyword: ["개인", "React", "styled-components"],
      image: "project_portfolio.png",
    },
  ];

  const careerRef = useRef(null);
  const projectRef = useRef(null);
  const [activeSection, setActiveSection] = useState(""); //navigation 활성화

  useEffect(() => {
    const careerArea = careerRef.current;
    const projectArea = projectRef.current;

    const observerOptions = {
      root: null, // 뷰포트 기준으로 감지
      rootMargin: "0px",
      threshold: 0.1, // 섹션의 10%가 보이면 활성화
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    if (careerArea) observer.observe(careerArea);
    if (projectArea) observer.observe(projectArea);

    return () => {
      observer.unobserve(careerArea);
      observer.unobserve(projectArea);
    };
  }, []);

  const handleNavClick = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView();
    }
  };

  const visible = { opacity: 1, y: 0, transition: { duration: 0.5 } };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible,
  };

  const handleCopyClipBoard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("이메일 주소가 복사되었습니다.");
    } catch (error) {
      console.log("이메일 주소 복사 실패");
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClick = (cardName) => {
    setSelectedCard(cardName);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  if (isModalOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  const haddleTopBtn = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <div>
      <GlobalStyle />
      <TopBtn onClick={haddleTopBtn}>
        <div>
          <IconTop />
        </div>
        <p>Back to Top</p>
      </TopBtn>
      <Intro
        initial="hidden"
        whileInView="visible"
        variants={{ visible: { transition: { staggerChildren: 0.3 } } }}
      >
        <Container>
          <Header
            variants={{
              hidden: { opacity: 0, y: -20 },
              visible,
            }}
          >
            <a
              href="https://github.com/gayeongogo"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div>
                <IconGithub />
                github
              </div>
            </a>
            <a
              href="https://velog.io/@gayeongogo/posts"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div>
                <IconVelog />
                velog
              </div>
            </a>
          </Header>
          <Main>
            <TextArea variants={itemVariants}>
              <div>
                <p>
                  <span>매일의 작은 성공</span>을 쌓아가며,
                </p>
                <p>
                  포기하지 않고 <span>도전</span>하는 프론트엔드 개발자
                </p>
                <p>
                  <b>고가연입니다.</b>
                </p>
              </div>
              <div>
                사용자가 자연스럽게 상호작용할 수 있는 <span>인터페이스</span>와
                <br />
                <span>애니메이션</span> 구현에 열정을 가지고 있습니다.
                <br />
                개발자의 가치는 <span>소통과 협업</span> 속에서 시너지를
                창출하는 것이라
                <br />
                믿습니다. 빠르게 변화하는 환경에서도 유연하게 적용할 수 있는
                <br />
                <span>새로운 기술</span>을 학습하며, 문제 해결을 위해{" "}
                <span>끊임없이 탐구하는 자세</span>로
                <br />
                성장하고 있습니다.
              </div>
            </TextArea>
            <ImageArea
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: false }}
              transition={{
                ease: "easeInOut",
                duration: 1,
                delay: 0.5,
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/mainphoto.png`}
                alt="가연"
              />
            </ImageArea>
          </Main>
        </Container>
      </Intro>
      <AboutMe>
        <Container>
          <Title>About Me</Title>
          <Values
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false }}
            transition={{
              ease: "easeInOut",
              duration: 1,
              x: { duration: 0.7 },
            }}
          >
            <ul>
              <li>
                항상 <B>사용자의 입장</B>을 최우선으로 생각하며,{" "}
                <B>사용자 경험 향상</B>을 위해 끊임없이 고민합니다.
              </li>
              <li>
                개발 과정에서 팀원 간의 원활한 <B>소통과 협업</B>을 중요시하고,{" "}
                <br />
                <B>피드백</B>을 소중히 여기며 적극 반영합니다.
              </li>
              <li>
                <B>꾸준한 기록</B>으로 지속적인 성장의 발판을 만들어 나갑니다.
              </li>
              <li>
                <B>빠른 적응력</B>과 <B>흡수력</B>으로 배움과 도전을 두려워하지
                않습니다.
              </li>
              <li>
                <B>React</B>, <B>Javascript</B> 그리고 <B>UI/UX Design</B>을
                공부하며 <br />
                역량을 강화하고 있습니다.
              </li>
            </ul>
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/images/mimoticon.png`}
                alt="미모티콘"
              />
            </div>
          </Values>
          <Skill>
            <SubTitle>⚙️ Skill & Tools</SubTitle>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{
                ease: "easeInOut",
                duration: 1,
                y: { duration: 0.7 },
              }}
            >
              <h3>많이 해봤어요</h3>
              <ul>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/react.svg`}
                    alt="React.js"
                  />
                  React.js
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/javascript.svg`}
                    alt=""
                  />
                  Javascript&#40;ES6+&#41;
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/file-type-html.svg`}
                    alt="HTML5"
                  />
                  HTML5
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/file-type-css.svg`}
                    alt="CSS3"
                  />
                  CSS3
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/file-type-styled.svg`}
                    alt="styled-components"
                  />
                  styled-components
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/tailwind-css.svg`}
                    alt="Tailwind CSS"
                  />
                  Tailwind CSS
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/markdown.svg`}
                    alt="Markdown"
                  />
                  Markdown
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/github.svg`}
                    alt="Github"
                  />
                  Github
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/figma.svg`}
                    alt="Figma"
                  />
                  Figma
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/adobe-photoshop.svg`}
                    alt="Photoshop"
                  />
                  Photoshop
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 70 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{
                ease: "easeInOut",
                duration: 1,
                y: { duration: 0.7 },
              }}
            >
              <h3>해본 적 있어요</h3>
              <ul>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/react.svg`}
                    alt="React Native"
                  />
                  React Native
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/jquery-plain.svg`}
                    alt="Jquery"
                  />
                  Jquery
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/typescript.svg`}
                    alt="Typescript"
                  />
                  Typescript
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/bootstrap.svg`}
                    alt="Bootstrap"
                  />
                  Bootstrap
                </li>
                <li>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/file-type-firebase.svg`}
                    alt="Firebase"
                  />
                  Firebase
                </li>
              </ul>
            </motion.div>
          </Skill>
          <Certi>
            <SubTitle>🏅 Certifications</SubTitle>
            <motion.div
              initial={{ opacity: 0, y: 70 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{
                ease: "easeInOut",
                duration: 1,
                y: { duration: 0.7 },
              }}
            >
              <CertiItem>
                <b>정보처리기사</b>
                <p>한국산업인력공단, 2024년 9월 취득</p>
              </CertiItem>
              <CertiItem>
                <b>GTQ&#40;그래픽기술자격&#41; 1급</b>
                <p>한국생산성본부, 2022년 3월 취득</p>
              </CertiItem>
              <CertiItem>
                <b>컴퓨터활용능력 2급</b>
                <p>대한상공회의소, 2022년 2월 취득</p>
              </CertiItem>
            </motion.div>
          </Certi>
        </Container>
      </AboutMe>
      <Experience>
        <ExContainer>
          <Nav>
            <NavItem
              $active={activeSection === "career"}
              onClick={() => handleNavClick(careerRef)}
            >
              Career
            </NavItem>
            <NavItem
              $active={activeSection === "project"}
              onClick={() => handleNavClick(projectRef)}
            >
              Project
            </NavItem>
          </Nav>
          <main>
            <Career id="career" ref={careerRef}>
              <CareerBox
                initial={{ opacity: 0, x: 70 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false }}
                transition={{
                  ease: "easeInOut",
                  duration: 1,
                  x: { duration: 0.7 },
                }}
              >
                <span>2023.07 &#126; 2024.02</span>
                <h3>(주)디로그</h3>
                <h4>디자인, 퍼블리싱, 프론트엔드 개발 담당</h4>
                <ul>
                  <li>Figma를 이용한 디자인 작업</li>
                  <li>
                    HTML, CSS를 활용해 웹 표준 및 웹 접근성을 고려한 퍼블리싱
                    작업
                  </li>
                  <li>
                    법무법인 웹사이트 리뉴얼&#40;리디자인 및 반응형 페이지&#41;
                  </li>
                  <li>React를 사용한 에너지 중개 사이트 개발 참여</li>
                  <li>React Native를 사용한 북마크 앱 디자인 및 개발 참여</li>
                  <li>제안서 및 산출물 디자인 요소 작업</li>
                </ul>
                <Tech
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{
                    ease: "easeInOut",
                    duration: 1,
                    y: { duration: 0.7 },
                  }}
                >
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/react.svg`}
                      alt="React"
                    />
                    <p>React.js</p>
                  </div>
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/tailwind-css.svg`}
                      alt="tailwind"
                    />
                    <p>Tailwind</p>
                  </div>
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/figma.svg`}
                      alt="figma"
                    />
                    <p>Figma</p>
                  </div>
                  <div>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/react.svg`}
                      alt="react native"
                    />
                    <p>React Native</p>
                  </div>
                </Tech>
              </CareerBox>
            </Career>
            <Project id="project" ref={projectRef}>
              <Cards
                initial={{ opacity: 0, y: 70 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{
                  ease: "easeInOut",
                  duration: 1,
                  y: { duration: 0.7 },
                }}
              >
                {cardData.map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => handleCardClick(`Card ${index + 1}`)}
                  >
                    <CardImg>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${item.image}`}
                        alt={`project ${index + 1}`}
                      />
                    </CardImg>
                    <CardInfo>
                      <h3>{item.title}</h3>
                      <span>{item.period}</span>
                      <p>{item.summary}</p>
                      <ul>
                        {item.keyword.map((kw, index) => (
                          <Keyword key={index} $keyword={kw}>
                            {kw}
                          </Keyword>
                        ))}
                      </ul>
                    </CardInfo>
                  </Card>
                ))}
              </Cards>
              {isModalOpen && (
                <Modal selectedCard={selectedCard} onClose={closeModal} />
              )}
            </Project>
          </main>
        </ExContainer>
      </Experience>
      <Thanks>
        <div>
          <h1>Thank You!</h1>
          <motion.h2
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{
              ease: "easeInOut",
              duration: 1.3,
              y: { duration: 0.7 },
            }}
          >
            저와 함께 작업하고 싶거나, 더 많은 정보를 원하신다면 언제든지
            연락주세요.
            <br />
            끝까지 봐주셔서 감사합니다.
          </motion.h2>
          <Contact
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: false }}
            transition={{
              ease: "easeInOut",
              duration: 1.5,
            }}
          >
            <Github>
              <a
                href="https://github.com/gayeongogo"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/contact-github.png`}
                  alt="github"
                />
              </a>
            </Github>
            <Email>
              <EmailLink
                onClick={() => handleCopyClipBoard("rkdus1357@gmail.com")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/contact-mail.png`}
                  alt="email"
                />
              </EmailLink>
              <p>rkdus1357@gmail.com</p>
            </Email>
          </Contact>
        </div>
        <Footer>
          <p>
            본 페이지는 상업적 목적이 아닌 개인 포트폴리오용으로 만들어진
            사이트입니다.
            <br />
            Copyright 2024. gogayeon all rights reserved.
          </p>
        </Footer>
      </Thanks>
    </div>
  );
}

export default App;
